// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3qIzB","visuallyhidden":"qLjRZ","hide-text":"_2cQFn","center":"_1L8u2","noprint":"_2Ym7F","root":"_2NTkF","text":"Rb55y"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-blockquote/styles/Blockquote.scss
 ** module id = 935
 ** module chunks = 1
 **/